import { BASE_CHART_URL } from "../../shared";
import api from "../../utils/authFetch";

export const fetchBirthChart = async ({ userId }) => {
  try {
    const res = await api.get(`/worker/admin/chart/birth/${userId}`);
    return res.data;
  } catch (err) {
    console.error("Birth chart error:", err?.response?.data || err.message);
    return null;
  }
};

export const fetchYearChart = async ({ userId, year, timezone }) => {
  try {
    const res = await api.post(`/worker/admin/chart/year`, {
      userId,
      ...(year && { year }),
      userCurrentTimezone: timezone,
    });
    return res.data;
  } catch (err) {
    console.error("Year chart error:", err?.response?.data || err.message);
    return null;
  }
};

export const fetchMonthChart = async ({ userId, year, month, timezone }) => {
  try {
    const res = await api.post(`/worker/admin/chart/month`, {
      userId,
      month: Number(month),
     ...(year && { year }),
      userCurrentTimezone: timezone,
    });
    return res.data;
  } catch (err) {
    console.error("Day chart error:", err?.response?.data || err.message);
    return null;
  }
};

export const fetchDayChart = async ({ userId, year, month, day, timezone }) => {
  try {
    const res = await api.post(`/worker/admin/chart/day`, {
      userId,
      month: Number(month),
      day: Number(day),
      ...(year && { year }),
      userCurrentTimezone: timezone,
    });
    return res.data;
  } catch (err) {
    console.error("Day chart error:", err?.response?.data || err.message);
    return null;
  }
};

export const fetchDivisionalChart = async ({ userId, type})=>{
  try {
    const res = await api.get(`/worker/admin/chart/divisional/${userId}?divisionalChartType=${type}`);
    return res.data;
  } catch (err) {
    console.error(`${type} chart error:, ${err?.response?.data || err.message}`);
    return null;
  }
}

export const fetchUserKarkas = async ({userId})=>{
   try {
    const res = await api.get(`/worker/admin/dasha/chara-karkas/${userId}`);
    return res.data;
  } catch (err) {
    console.error("Karkas error:", err?.response?.data || err.message);
    return null;
  }
}
// export const fetchChaturthamsaChart = async ({ userId }) => {
//   try {
//     const res = await api.get(`/worker/admin/chart/chaturthamsa/${userId}`);
//     return res.data;
//   } catch (err) {
//     console.error("Chaturthamsa chart error:", err?.response?.data || err.message);
//     return null;
//   }
// };

// export const fetchSaptamsaChart = async ({ userId }) => {
//   try {
//     const res = await api.get(`/worker/admin/chart/saptamsa/${userId}`);
//     return res.data;
//   } catch (err) {
//     console.error("Saptamsa chart error:", err?.response?.data || err.message);
//     return null;
//   }
// };

// export const fetchNavamsaChart = async ({ userId }) => {
//   try {
//     const res = await api.get(`/worker/admin/chart/navamsa/${userId}`);
//     return res.data;
//   } catch (err) {
//     console.error("Navamsa chart error:", err?.response?.data || err.message);
//     return null;
//   }
// };

// export const fetchDasamsaChart = async ({ userId }) => {
//   try {
//     const res = await api.get(`/worker/admin/chart/dasamsa/${userId}`);
//     return res.data;
//   } catch (err) {
//     console.error("Dasamsa chart error:", err?.response?.data || err.message);
//     return null;
//   }
// };

// export const fetchDwadamsaChart = async ({ userId }) => {
//   try {
//     const res = await api.get(`/worker/admin/chart/dwadamsa/${userId}`);
//     return res.data;
//   } catch (err) {
//     console.error("Dwadamsa chart error:", err?.response?.data || err.message);
//     return null;
//   }
// };


export const fetchTransitChart = async ({ userId, year, month, day, timezone }) => {
  try {
    const res = await api.post(`/worker/admin/chart/transit`, {
      userId,
      year: Number(year),
      month: Number(month),
      day: Number(day),
      userCurrentTimezone: timezone,
    });
    return res.data;
  } catch (err) {
    console.error("Transit chart error:", err?.response?.data || err.message);
    return null;
  }
};


export const buildChartUrl = (chartData, currentH1 = 1) => {
    if (!Array.isArray(chartData)) return null;

    const queries = chartData
        .flatMap(house =>
            Array.isArray(house.planet)
                ? house.planet.map(
                    planet => `${planet.toLowerCase()}=${house.house}`
                )
                : []
        )
        .filter(Boolean);

    if (!queries.length) return null;

    return `${BASE_CHART_URL}?h1=${currentH1}&brand=0&${queries.join("&")}`;
};
